/** pt-BR labels for enum/slug values shown in lists and filters. */

export const INVESTMENT_CATEGORY_LABELS: Record<string, string> = {
  crypto: 'Cripto',
  offshore: 'Offshore',
  stocks: 'Ações',
  fixed_income: 'Renda Fixa',
  funds: 'Fundos',
  other: 'Outros',
};

export const PHILANTHROPY_CATEGORY_LABELS: Record<string, string> = {
  education: 'Educação',
  health: 'Saúde',
  environment: 'Meio Ambiente',
  other: 'Outros',
};

export const VESSEL_CATEGORY_LABELS: Record<string, string> = {
  boat: 'Barco',
  yacht: 'Iate',
  sailboat: 'Veleiro',
  other: 'Outro',
};

export const AIRCRAFT_CATEGORY_LABELS: Record<string, string> = {
  airplane: 'Avião',
  helicopter: 'Helicóptero',
  other: 'Outro',
};

export const ASSET_TYPE_LABELS: Record<string, string> = {
  real_estate: 'Imóvel',
  other: 'Outros',
  vehicle: 'Veículo',
  vessel: 'Embarcação',
  aircraft: 'Aeronave',
};

export function investmentCategoryLabel(slug?: string | null): string {
  if (!slug) return '—';
  return INVESTMENT_CATEGORY_LABELS[slug] || slug;
}

export function philanthropyCategoryLabel(slug?: string | null): string {
  if (!slug) return '—';
  return PHILANTHROPY_CATEGORY_LABELS[slug] || slug;
}

export function vesselCategoryLabel(slug?: string | null): string {
  if (!slug) return '—';
  return VESSEL_CATEGORY_LABELS[slug] || slug;
}

export function aircraftCategoryLabel(slug?: string | null): string {
  if (!slug) return '—';
  return AIRCRAFT_CATEGORY_LABELS[slug] || slug;
}

export function assetTypeLabel(slug?: string | null): string {
  if (!slug) return '—';
  return ASSET_TYPE_LABELS[slug] || slug;
}

/** Fontes de importação / marcação gravadas em price history (não exibir o enum cru). */
export const IMPORT_SOURCE_LABELS: Record<string, string> = {
  manual: 'Atualização manual',
  b3_posicao: 'Posição B3',
  b3_movimentacao: 'Movimentação B3',
  xp: 'XP Investimentos',
  clear: 'Clear',
  btg: 'BTG Pactual',
};

export function importSourceLabel(fonte?: string | null): string {
  if (!fonte) return 'Marcação a mercado';
  return IMPORT_SOURCE_LABELS[fonte] || 'Outra fonte';
}

/** Descrição de movimentação de preço — rótulo humano, nunca a chave (ex.: b3_posicao). */
export function priceMovementDescription(fonte?: string | null): string {
  if (!fonte) return 'Marcação a mercado';
  if (fonte === 'manual') return 'Atualização manual — preço de mercado';
  const label = IMPORT_SOURCE_LABELS[fonte];
  if (!label) return 'Importação — preço de mercado';
  return `${label} — preço de mercado`;
}
